import { CompanyMoneyBackGuarantee } from '@/components/company/CompanyMoneyBackGuarantee';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Header, withLayout } from '../../components';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="返金保証について" />
      <Header />
      <CompanyMoneyBackGuarantee />
    </>,
  );
};

export default Page;
